import { render, staticRenderFns } from "./vw-flat-rate-search-results-view.vue?vue&type=template&id=45c18e7e&scoped=true&"
import script from "./vw-flat-rate-search-results-view.vue?vue&type=script&lang=js&"
export * from "./vw-flat-rate-search-results-view.vue?vue&type=script&lang=js&"
import style0 from "./vw-flat-rate-search-results-view.vue?vue&type=style&index=0&id=45c18e7e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c18e7e",
  null
  
)

export default component.exports